import Alert from '@mui/material/Alert';

const CustomAlert = props => {
  const { message, severity } = props;

  return (
    <Alert variant="filled" sx={{ mb: 3, fontSize: '16px', width: '40%' }} severity={severity}>
      {message}
    </Alert>
  );
};

export default CustomAlert;
